import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { TimeSelector } from "@/Common/Components/Inputs/TimeSelector";

import "./CommunicationComponentsCommon.css";

interface ITaskEditComponentProps {
    selectedGroupTypeId: string;
    startDate: Date;
    dueDate: Date;

    onTypeSelectionChange: (typeOfTask: string) => void;
    onStartDateChange: (date: Date) => void;
    onDueDateChange: (date: Date) => void;
    onStartTimeChange: (startTime: Date) => void;
    onDueTimeChange: (dueTime: Date) => void;
}

class TaskEditComponent extends React.Component<ITaskEditComponentProps, any> {
    public render(): JSX.Element {
        const self = this;
        return (
            <div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-lg-2 col-md-3 col-sm-12 label-text-alignment" style={{ paddingTop: "10px" }}>
                        <label className="form-label">{cacheStore.GetString("TaskTypeLabel")}</label>
                    </div>
                    <div className="col-lg-6 col-md-9 col-sm-12 ">
                        {communicationsStore.GetTaskGroupingTypes().map((item, idx) => (
                            <div key={item.Key + idx} className="tbc">
                                <div className="radio" style={{ marginRight: "15px" }}>
                                    <label htmlFor={`i_${item.Key}`}>
                                        <input
                                            id={`i_${item.Key}`}
                                            type="radio"
                                            data-action="task_radio"
                                            name="something"
                                            onChange={(e: any) => self.props.onTypeSelectionChange(e.target.value)}
                                            value={item.Key}
                                            checked={self.props.selectedGroupTypeId == item.Key}
                                        />
                                        {item.Value}
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-2 col-md-3 col-sm-12 vcenter label-text-alignment" style={{ paddingTop: "3px" }}>
                        <label className="form-label">{cacheStore.GetString("StartDateLabel")}</label>
                    </div>

                    <div className="col-lg-10 col-md-9 col-sm-12">
                        <div className="tb" style={{ width: "450px" }}>
                            <div className="tbc" style={{ paddingRight: "15px" }}>
                                <DateSelector
                                    id="task_start_date"
                                    dataCy="task-start-date"
                                    date={self.props.startDate}
                                    onChangeCallback={date => this.props.onStartDateChange(date)}
                                    dateFormat="yyyy-MM-dd"
                                    disabled={false}
                                    toDayEnabled={true}
                                />
                            </div>
                            <div className="tbc">
                                <TimeSelector
                                    id="task_time_start"
                                    dataCy="task-start-time"
                                    date={self.props.startDate}
                                    onChangeCallback={date => this.props.onStartTimeChange(date)}
                                    dateFormat="HH:mm"
                                    disabled={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-2 col-md-3 col-sm-12 vcenter label-text-alignment" style={{ paddingTop: "3px" }}>
                        <label className="form-label">{cacheStore.GetString("DueDateLabel")}</label>
                    </div>
                    <div className="col-lg-10 col-md-9 col-sm-12">
                        <div className="tb" style={{ width: "450px" }}>
                            <div className="tbc" style={{ paddingRight: "15px" }}>
                                <DateSelector
                                    id="task_end_date"
                                    dataCy="task-end-date"
                                    date={self.props.dueDate}
                                    onChangeCallback={date => this.props.onDueDateChange(date)}
                                    dateFormat="yyyy-MM-dd"
                                    disabled={false}
                                    toDayEnabled={true}
                                />
                            </div>
                            <div className="tbc">
                                <TimeSelector
                                    id="task_time_end"
                                    dataCy="task-end-time"
                                    date={self.props.dueDate}
                                    onChangeCallback={date => this.props.onDueTimeChange(date)}
                                    dateFormat="HH:mm"
                                    disabled={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { TaskEditComponent };
